/**
 * @fileoverview This file was generated by the Angular template compiler. Do not edit.
 *
 * @suppress {suspiciousCode,uselessCode,missingProperties,missingOverride,checkTypes}
 * tslint:disable
 */ 
var styles = [".happ-toolbar-simple[_ngcontent-%COMP%]{padding:0 10px;border:1px solid #dcdcdc;border-radius:9px;border-top:0}"];
export { styles as styles };
